import React, { useContext, useState } from 'react'
import { faAdd, faClose, faDiagramProject, faMapLocationDot, faPlusSquare, faStickyNote, faUserGroup, faUserCircle, faBullseye, faHouseFloodWaterCircleArrowRight, faNoteSticky, faBookOpen, faPager, faBook, faMinimize, faMaximize, faTrash, faListCheck, faMinus, faSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NormalInput from '../components/NormalInput'
import NormalTextArea from '../components/NormalTextArea'
import SelectorInput from '../components/SelectorInput'
import IconButton from '../components/IconButton'
import FactorItem from './FactorItem'
import AppContext from '../contexts/AppContext'


export default function CriteriaItem({ criteria, index, criterias, setCriterias }) {
    const {openModal} = useContext(AppContext)
    return (
        <div className='border border-3 border-gray-300 rounded-t-xl p-5'>
            <div className={`transition-all ease-linear duration-100 cursor-pointer ${criteria.minimize ? 'h-[120px] overflow-hidden' : 'h-[450px] overflow-y-scroll overflow-x-hidden'}`}>
                <div className={`flex justify-end items-center`}>
                    <FontAwesomeIcon onClick={() => {
                        const c = [...criterias]
                        c[index].minimize = !c[index].minimize
                        setCriterias(c)
                    }} className='h-3 w-3 flex justify-center hover:text-white hover:bg-gray-500 border-2 border-gray-400 p-1 rounded items-center' icon={!criteria.minimize ? faMinus : faMaximize} size='sm' />
                    <FontAwesomeIcon onClick={() => {
                        let c = [...criterias]
                        c = c.filter((crit) => crit != criteria)
                        openModal("Delete criteria?", `Are you sure you want to delete "${criteria.criteria}"`, ()=>{c = c.filter((crit) => crit != criteria); setCriterias(c)})
                    }} className='h-3 w-3 ml-2 flex justify-center hover:text-white hover:bg-red-600/70 text-red-600/70 border-2 border-gray-400 p-1 rounded items-center' icon={faTrash} size='sm' />
                </div>
                <NormalInput icon={faBullseye} name={'criteria'} value={criteria.criteria} onChange={(e) => {
                    const c = [...criterias]
                    c[index].criteria = e.target.value
                    setCriterias(c)
                }} placeholder={'criteria name'} />
                <NormalTextArea value={criteria.description} onChange={(e) => {
                    const c = [...criterias]
                    c[index].description = e.target.value
                    setCriterias(c)
                }} icon={faBook} name={'description'} boxClassName={'mb-5'} rows={'1'} placeholder={'criteria description'} />
                <div>
                    {
                        criteria.factors.map((factor, i) => {
                            const factor_rank = factor.score ? Math.round((criteria.factors.length + 1 - Math.round(criteria.factors.length * factor.score))) : i + 1
                            return (
                                <FactorItem frank={factor_rank} factor={factor} criteria={criteria} i={i} setCriterias={setCriterias} criterias={criterias} parentIndex={index} key={i} />
                            )
                        }
                        )

                    }
                </div>
                <div className='w-full mt-5 ml-10'>
                    <IconButton icon={faHouseFloodWaterCircleArrowRight} onClick={() => {
                        const c = [...criterias]
                        c[index].factors.push({ name: '', description: '', score: null })
                        setCriterias(c)
                    }} title={'Add impact factor'} />
                </div>
            </div>
        </div>
    )
}
